import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { LetDirective } from '@ngrx/component';
import { ConfigPanelToggleComponent } from './config-panel-toggle/config-panel-toggle.component';
import { ConfigPanelComponent } from './config-panel/config-panel.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, LetDirective, MatRadioModule, MatSlideToggleModule, MatRippleModule, MatSliderModule],
  declarations: [ConfigPanelComponent, ConfigPanelToggleComponent],
  exports: [ConfigPanelComponent, ConfigPanelToggleComponent]
})
export class CoreConfigPanelModule {}
